import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of, Subscription, timer } from 'rxjs';
import { catchError, map, switchMap, take, takeWhile, tap } from 'rxjs/operators';
import {
  PackageProcessOrder,
  PackageService,
} from 'src/app/shared/services/http-services/package.service';

/**
 * Paymob browser return (`/billing/return`) — shared by package + subscription checkouts.
 * If a package process order exists → Success Page; else candidate home.
 */
@Component({
  selector: 'app-billing-return',
  templateUrl: './billing-return.component.html',
  styleUrls: ['./billing-return.component.scss'],
})
export class BillingReturnComponent implements OnInit, OnDestroy {
  message = 'جاري تأكيد الدفع…';
  private sub?: Subscription;
  private readonly maxAttempts = 12;
  private attempts = 0;
  private done = false;

  constructor(
    private packages: PackageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sub = timer(0, 1500)
      .pipe(
        takeWhile(() => !this.done),
        switchMap(() => {
          this.attempts += 1;
          if (this.attempts > 3) {
            this.message = 'ننتظر تأكيد الدفع من المزود… لحظات';
          }
          return this.packages.getMyProcessOrder().pipe(
            map((res: any) =>
              res?.succeeded ? (res.data as PackageProcessOrder) : null,
            ),
            catchError(() => of(null)),
          );
        }),
        tap((order) => {
          if (order?.canOpenSuccessPage) {
            this.done = true;
            this.router.navigate(['/app/candidate/packages/process/success'], {
              queryParams: {
                orderId: order.id,
                packageId: order.packageId,
              },
            });
            return;
          }
          if (this.attempts >= this.maxAttempts) {
            this.done = true;
            this.message = 'تم الدفع. جارٍ تحويلك…';
            this.router.navigate(['/app/candidate/home']);
          }
        }),
        take(this.maxAttempts),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
